<template>
  <div class="basic_progress ">
    <div class="tooptipPart all_tooptipPart">
      
        <my_edit_btn
          :module="module"
          :title="$t('widgets_basic_article_classification_index_336')"
        ></my_edit_btn>
        <my_edit_btn
          :module="module"
          tabName="animation"
          :title="$t('widgets_basic_article_classification_edit_330')"
          v-if="$store.state.app.view_pattern === 'pc'"
        ></my_edit_btn>
        <my_link_btn
          :module="module"
          :title="$t('components_my_link_index_2361')"
          v-if="$store.state.app.view_pattern === 'pc'"
        ></my_link_btn>
        <my_close_btn
          :module="module"
          :column="column"
          :moduleIndex="module_index"
          :title="$t('widgets_basic_article_list_index_414')"
          v-if="$store.state.app.view_pattern === 'pc'"
        ></my_close_btn>
     
    </div>
    <div
      class="coverPart"
      @click="clickTime"
    >
      <div class="contentPart">
        <set_link
          class="linkPart"
          :sendData="module.data.listArr.link"
          v-if="module.widgets_id !== editID"
        ></set_link>
        <!--  :contenteditable="$store.state.app.view_pattern === 'pc'" -->
        <!-- 这边和预览没有关系 -->
        <div :id="'editDiv' + module.widgets_id">
          <!-- left right bottom top progress-bg-pc -->
          <div
            class="progress-bg height_fill "
            :class="[moduleSet[moduleSet.radio_val].direction]"
            :style="{
              height: module.data.pc_widgets_infor.height + 'px',
              ...backgroundStart,
              borderRadius: borderRadius,
              border: borderStyle,
              'box-sizing': 'border-box',
              padding: paddingStyle
            }"
          >
            <div
              class="progress-inner"
              v-if="moduleSet.radio_val === 'left_right'"
              :class="[moduleSet.radio_val,moduleSet[moduleSet.radio_val].direction]"
              :id="'countUp' + module.widgets_id"
              :style="{
                ...backgroundEnd,
                width: `${width}%`,
                borderRadius: borderRadius,
                height: `100%`,
                // ...linear_gradient
               
              }"
            >
              <span
                :id="'countUp' + module.widgets_id + 'inner'"
                :style="{
                  ...fontStyle
                }"
              ></span>
            </div>
            <div
              class="progress-inner"
              v-else
              :class="[moduleSet.radio_val,moduleSet[moduleSet.radio_val].direction]"
              :id="'countUp' + module.widgets_id"
              :style="{
                ...backgroundEnd,
                width: `100%`,
                borderRadius: borderRadius,
                height: `${width}%`}"
            >
              <span
                :id="'countUp' + module.widgets_id + 'inner'"
                :style="{...fontStyle}"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import i18n from '../../language/index'

import { CountUp } from "countup.js";
export default {
  name: "basic_progress",
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      count_up: null,
      start: 0,
      end: 0,
      target: 0
    };
  },
  computed: {
    editID() {
      if (this.$store.state.app.module_Data) {
        return this.$store.state.app.module_Data.widgets_id;
      } else {
        return 0;
      }
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor;
    },
    mb_widgets_infor() {
      return this.module.data.mb_widgets_infor;
    },
    height() {
      return this.infor.height;
    },
    infor() {
      return this.module.data[this.$store.state.app.view_pattern + "_widgets_infor"];
    },
    fontStyle() {
      let fontStyle = {};
      let font = this.infor.font[
        this.infor.font.radio_val
      ];
      fontStyle.fontSize = font.fontSize + "px";
      fontStyle.fontFamily = font.fontFamily;
      fontStyle.fontStyle = font.fsItalics;
      fontStyle.fontWeight = font.fsWeight;
      if (font.pattern == "linear_gradient") {
        fontStyle.webkitBackgroundClip = "text";
        fontStyle.webkitTextFillColor = "transparent";
        fontStyle.color = "";
        fontStyle.backgroundImage =
          "linear-gradient(" +
          font.linear_gradient.deg +
          "deg," +
          font.linear_gradient.start_color +
          font.linear_gradient.start_pointer +
          "%," +
          font.linear_gradient.end_color +
          font.linear_gradient.end_pointer +
          "%)";
      } else {
        fontStyle.color = font.fontColor_globalColor;
      }

      return fontStyle;
    },
    fontStyle_PC() { // 字PC
      return this.font_style('pc');
    },
    fontStyle_MB() { // 字体手机
      return this.font_style('mb')
    },
    moduleSet() { // 模式设置 之后 PC端显示
      return this.pc_widgets_infor.moduleSet
    },
    backgroundStart(){
      return this.background_style(this.$store.state.app.view_pattern, 'Start')
    },
    backgroundEnd(){
      return this.background_style(this.$store.state.app.view_pattern, 'End')
    },
    borderStyle() {
      return this.border_style(this.$store.state.app.view_pattern)
    },
    paddingStyle(){
      return this.padding_style(this.$store.state.app.view_pattern)
    },
    borderRadius(){
      return this.border_radius(this.$store.state.app.view_pattern)
    },
    width() {
      let percent = 0;
      if (!this.count_up || this.end - this.start <= 0) return percent;
      return (
        ((this.count_up.frameVal - this.start) / (this.end - this.start)) * 100
      );
    },
  },
  mounted() {
    let infor = this.pc_widgets_infor;
    this.delay = this.$store.state.app.road_type == 1? 0:infor.playSet[infor.playSet.radio_val].delay;
    
    this.init();
    this.initData();
  },
  methods: {
    init() {
      // start 是开始的数值 target 是结束的数值
      let { start, target, end, decimalPlaces, useGrouping } = { ...this.module.data.animation_set }; // floatNum
      this.start = start;
      this.end = end;
      let infor = this.pc_widgets_infor;
    
      let option = {
        startVal: start,
        decimalPlaces: decimalPlaces, // 小数的位数数
        duration:  this.$store.state.app.road_type == 1? 0.001:infor.playSet[infor.playSet.radio_val].duration,
        useGrouping: useGrouping,
        suffix: useGrouping? `/${this.formatNumber(end)}`:`/${end}`
        /* formattingFn: function(number) {
          return `${number}/${end}`;
        } */
      };
      let dom = document.querySelector('.pc_pattern') ?  `countUp${this.module.widgets_id}inner` : `countUp${this.module.widgets_id}inner`
      this.count_up = new CountUp(
        dom,
        target,
        option
      );
    },

    initData() {
      if(this.set_timer){
        clearInterval(this.set_timer)
        this.set_timer = null
      }
      // :id="'editDiv' + module.widgets_id"
      let dom = document.getElementById(`editDiv${this.module.widgets_id}`);
      // 判断 要不要产生滚动条
      let client_height =
        window.innerHeight || document.documentElement.clientHeight; // 屏幕高度
      let body_height = document.body.scrollHeight;
      let top_satrt = dom.getBoundingClientRect().top;
      let scroll_dom = this.$store.state.app.view_pattern == 'pc' ? window : '.mb_body_view'
     
      if (client_height > body_height || top_satrt < client_height) {
        // 这个
        // console.log('挂件不滚动执行',top_satrt, this.set_timer)
        this.set_timer = setTimeout(() => {
          // this.numberChange()
          if (!this.count_up.error) this.count_up.start();
        }, this.delay * 1000);
      } else {
        $(scroll_dom).scroll(() => {
          let top = dom.getBoundingClientRect().top;
          // console.log('初始化滚动',top, this.set_timer, client_height)
          
          if (top <= client_height && !this.set_timer) {
            this.set_timer = setTimeout(() => {
              if (!this.count_up.error) this.count_up.start();
              // this.numberChange()
            }, this.delay * 1000);
          }
          // console.log('DOM的offsetTop' ,dom.getBoundingClientRect().top)
        });
      }
    },
    clickTime() {
      /* if(this.$store.state.app.view_pattern !== 'pc'){
        return false;
      } */
      let that = this;
      $("#u" + that.module.widgets_id)
        .find(".contentPart")
        .addClass("focusDiv");
      if (this.module.widgets_id === this.editID) {
        return false;
      }
      /*  var range = document.createRange();
      range.selectNodeContents(document.getElementById('editDiv' + this.module.widgets_id));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range); */
      // that.templet.set_focus(that.module.widgets_id);
    },
    font_style(type) { // 字体设置
      let fontStyle = {};
      let infor = this[`${type}_widgets_infor`];
      let font = infor.font[
        infor.font.radio_val
      ];
      fontStyle.fontSize = font.fontSize + "px";
      fontStyle.fontFamily = font.fontFamily;
      fontStyle.fontStyle = font.fsItalics;
      fontStyle.fontWeight = font.fsWeight;
      // fontStyle.textAlign = font.textAlign;
      fontStyle.textDecoration= font.fontUnderline;
      // this.pc_widgets_infor.height
      fontStyle.lineHeight = this[`height_${type}`] + 'px'
      if (font.pattern == "linear_gradient") {
        fontStyle.webkitBackgroundClip = "text";
        fontStyle.webkitTextFillColor = "transparent";
        fontStyle.color = "";
        fontStyle.backgroundImage = 'linear-gradient(' + font.linear_gradient.deg + 'deg,' + font.linear_gradient.start_color +
      font.linear_gradient.start_pointer + '%,' + font.linear_gradient.end_color + font.linear_gradient.end_pointer +
      '%)'
      } else {
        fontStyle.color = font.fontColor_globalColor;
      }
      return fontStyle;
    },
    background_style(type, position){ // 背景设置
      let background = this[`${type}_widgets_infor`][`background${position}`]
      if (background.radio_val === "hidden") {
        return {
          background: "transparent"
        };
      }
      return {
        backgroundColor: background[
          background.radio_val
        ].color,
        backgroundImage:
          "url(" +
          (background[
            background.radio_val
          ].img || "") +
          ")",
        backgroundSize: background[
          background.radio_val
        ].background_size,
        backgroundRepeat:background[
          background.radio_val
        ].background_repeat,
        backgroundPosition: background[
          background.radio_val
        ].background_position
      };
    },
    border_style(type) {
      let border = this[`${type}_widgets_infor`].border;
      if (border.radio_val === "hidden") {
        return "none";
      } else {
        /* let border = "";
        border +=border[border.radio_val].borderStyle + " ";
        border +=border[border.radio_val].borderColor + " ";
        border +=border[border.radio_val].borderWidth + "px"; */
        return `${border[border.radio_val].borderWidth}px ${border[border.radio_val].borderStyle} ${border[border.radio_val].borderColor}`;
      }
    },
    padding_style(type) {
      let infor = this[`${type}_widgets_infor`];
      /* padding += `${this.infor.box_paddingTop}` + " ";
      padding += `${this.infor.box_paddingRight}` + " ";
      padding += `${this.infor.box_paddingBottom}` + " ";
      padding += `${this.infor.box_paddingLeft}` + " "; */
      let padding = `${infor.box_paddingTop} ${infor.box_paddingRight} ${infor.box_paddingBottom} ${infor.box_paddingLeft}`
      return padding;
    },
    border_radius(type) {
      let infor = this[`${type}_widgets_infor`];
      // return this.infor.borderRadius;
      return `${infor.borderRadius[infor.borderRadius.radio_val].value}px`
    },
    //  JS 数字千分位分割
    formatNumber(num) {
      var source = String(num).split(".");//按小数点分成2部分
      source[0] = source[0].replace(new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'), "$1,");//只将整数部分进行都好分割
      return source.join(".");//再将小数部分合并进来
    }
  },
  watch: {
    "module.data.animation_set.start"() {
      let infor = this.pc_widgets_infor;
      this.delay = infor.playSet[infor.playSet.radio_val].delay;
      this.init();
      this.initData();
    },
    "module.data.animation_set.target"() {
      let infor = this.pc_widgets_infor;
      this.delay = infor.playSet[infor.playSet.radio_val].delay;
      this.init();
      this.initData();
    },
    "module.data.animation_set.end"() {
      let infor = this.pc_widgets_infor;
      this.delay = infor.playSet[infor.playSet.radio_val].delay;
      this.init();
      this.initData();
    },
    '$store.state.app.view_pattern'(val) { // pc  和手机初始化的时候 动态数字初始化
      
      this.init();
      this.initData()
    }
  }
};
</script>

<style scoped lang="scss">
.progress-bg {
  display: flex;
  .progress-inner {
    display: flex;
    overflow: hidden;
  }
  .left_right {
    align-items: center;
    justify-content: flex-end;
    padding: 0 10px;
    box-sizing:border-box;
  }
  &.right {
    .left_right {
      justify-content: flex-start;
    }
  }
  &.right,
  &.bottom {
    justify-content: flex-end;
  }
  &.bottom,
  &.top {
    flex-direction: column;
  }
  &.top {
    .bottom_top {
      align-items: flex-end;
    }
  }
  .bottom_top {
    justify-content: center;
  }
}
.pc_pattern{
  .progress-bg-mb{
    display: none;
  }
}
.mb_pattern{
  .progress-bg-pc{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_progress/index.vue